import { Rank } from '../../sim/defs';
import { Fam } from '../../sim/pools/BulletPool';
import { CYCLE, firstDelayAt, PHASE_FUSEAUX } from '../bosses/navette.cycle';
import { defineEnemy, Motion, Pattern } from '../schema';

/** B02-b — FUSEAU DE LA NAVETTE. Partie destructible, montée par paire (±76 u).
 *
 *  ── Rôle : la trace de la traversée ──
 *  850 PV, la partie bon marché, celle que le joueur abat en premier sans y
 *  penser — même fonction pédagogique que la nacelle du Héraut : découvrir que
 *  le noyau est intouchable en tirant à côté par accident.
 *
 *  Mais son anneau fait ici un travail que celui de la nacelle ne faisait pas.
 *  Le porteur se déplace pendant l'émission, si bien que les deux anneaux
 *  laissent derrière eux une TRAÎNÉE de projectiles le long du chemin parcouru.
 *  Le terrain se referme donc dans le dos de la Navette, et l'espace libre est
 *  toujours DEVANT elle.
 *
 *  C'est ce qui rend le contresens payant sans qu'aucun texte ne le dise : le
 *  joueur qui suit le boss traverse sa propre traînée, celui qui le croise passe
 *  par le vide qu'elle n'a pas encore comblé. La règle du monde 2 — se déplacer
 *  dans le bon sens plutôt que s'arrêter — est écrite là, dans la géométrie.
 *
 *  ── Rotation ──
 *  `stepDeg` décale l'anneau de 11° d'un cycle à l'autre, pour que deux
 *  pulsations successives ne se superposent jamais. Sans elle, la traînée
 *  formerait des couloirs fixes et le joueur mémoriserait une place sûre — la
 *  figure cesserait d'être une figure. */
export default defineEnemy({
  id: 'navette-fuseau',
  rank: Rank.Standard,
  hp: 800,
  visualRadius: 24,
  score: 750,
  telegraph: 2.2,
  drops: 2,
  motion: { kind: Motion.Hover, speed: 0, amplitude: 0, frequency: 0, holdY: 345 },
  emitter: {
    pattern: Pattern.Ring,
    every: CYCLE,
    count: 14,
    spreadDeg: 0,
    // 280 u/s, l'émission la plus lente du combat : la traînée doit rester
    // longtemps en vol pour que le joueur la voie se construire derrière le
    // porteur. Une traînée qui s'efface trop vite ne raconte rien.
    speed: 280,
    stepDeg: 11,
    firstDelay: firstDelayAt(PHASE_FUSEAUX),
    family: Fam.EnemyRed,
  },
});
